const KEY_NAME = 'splash-modal-hidden';
const modal = document.getElementById('splash-modal');
const button = document.getElementById('splash-button');

const showSplashModal = () => {
  modal.classList.add('show');
  document.body.classList.add('splash-modal-show');
}

const hideSplashModal = () => {
  modal.classList.remove('show');
  document.body.classList.remove('splash-modal-show');
  localStorage.setItem(KEY_NAME, 'true');
}

button.addEventListener('click', hideSplashModal);

if (location.pathname === '/' && modal.hasAttribute('data-design-mode') || !localStorage.getItem(KEY_NAME)) {
  showSplashModal();
}
